import differenceInYears from "date-fns/differenceInYears";
import RallySSO from "./rallySSO";
import {get} from "lodash";
import {IS_SSO_BACKDOOR} from "data/constants";

export enum SSOErrors {
	Under21 = "under_21",
	NoDate = "no_date",
}

export enum SSOType {
	Rally = "rally",
	Web = "web",
}

interface IMlbOktaError {
	redirect: boolean;
	message: {
		errorCode: "login_required" | string;
		errorSummary: string;
		name: string;
	};
}

export class SSO {
	static IS_BACKDOOR_MODE = IS_SSO_BACKDOOR;
	private static BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || "";
	private static BASE_URL = process.env.REACT_APP_BASE_URL || "";
	// private token: string = "";
	private uuid: string = "";
	private email: string = "";
	private platform: string = "web";
	private type: SSOType = SSOType.Web;
	private error: SSOErrors | null = null;

	public async initRallySSO() {
		const mlbApi = new RallySSO();

		await mlbApi.init();

		// const token = await mlbApi.getAccessToken();
		const uid = await mlbApi.getUser();

		if (uid) {
			// this.token = token;
			this.uuid = uid;
			this.type = SSOType.Rally;
		} else {
			mlbApi.showAlert("Auth required");
		}
	}

	public async initWebAuthSSO() {
		try {
			if (!window.mlbOkta) {
				throw new Error("No mlb api found");
			}

			const result = await window.mlbOkta.isLoggedIn();

			// const token = result.accessToken.accessToken;
			const accessToken = get(result, "accessToken");
			const claims = get(accessToken, "claims");
			const uid = get(claims, "uid", "");
			const email = get(claims, "sub", "");

			// console.log("result---", result);
			// console.log("accessToken---", accessToken);

			if (!uid) {
				throw new Error("No credentials");
			}

			const checkAgeState = this.checkUnder21();

			if (checkAgeState) {
				this.error = checkAgeState;
			}

			// this.token = token;
			this.uuid = uid;
			this.email = email;
			this.type = SSOType.Web;
		} catch (e: unknown) {
			const error = e as IMlbOktaError;
			console.log("Before auth error: ", error);

			if (!error.redirect) {
				const errorMessage = get(error, "message");
				const message = get(errorMessage, "errorSummary", "Auth required");
				throw new Error(message);
			}

			// SSO.TO_PLAY_LOGIN_FORM();
		}
	}

	private checkUnder21 = (): SSOErrors | null => {
		const twentyOne = 21;
		const {birthYear, birthMonth, birthDay} = window.mlbOkta.decodeIdToken();
		const diff = differenceInYears(new Date(), new Date(birthMonth, birthDay, birthYear));

		if (isNaN(diff)) {
			return SSOErrors.NoDate;
		}

		if (diff < twentyOne) {
			return SSOErrors.Under21;
		}

		return null;
	};

	public static TO_MLB = () => {
		window.location.href = "https://www.mlb.com";
	};

	public static TO_PLAY_LOGIN_FORM = () => {
		window.location.href = `${SSO.BASE_DOMAIN}/play/login?redirectUri=${SSO.BASE_DOMAIN}${SSO.BASE_URL}`;
	};

	public static TO_GAME_REDIRECT = () => {
		window.location.href = `${SSO.BASE_DOMAIN}/play/auth?redirectUri=${SSO.BASE_DOMAIN}${SSO.BASE_URL}`;
	};

	public static TO_LOGIN_FORM = () => {
		window.location.href = `${SSO.BASE_DOMAIN}/login?redirectUri=${SSO.BASE_DOMAIN}${SSO.BASE_URL}`;
	};
	public static TO_LOGIN_BACK_TO_CONTEST = (gameId: number, lang: string) => {
		window.location.href = `${SSO.BASE_DOMAIN}/login?redirectUri=${SSO.BASE_DOMAIN}${SSO.BASE_URL}/${lang}/contest/${gameId}`;
	};

	public static TO_LOGIN_ON_BOARDING = () => {
		window.location.href = `${SSO.BASE_DOMAIN}/play/onboarding?step=updateAccount`;
	};

	public getType() {
		return this.type;
	}

	public getError() {
		return this.error;
	}

	public toJSON() {
		return {
			// token: this.token,
			platform: this.platform,
			uid: this.uuid,
			email: this.email,
		};
	}
}
